// extracted by mini-css-extract-plugin
export default {"container":"Tooltip_container__nPCY3","title":"Tooltip_title__3pH7Y"};